module.exports = __webpack_public_path__ + "img/9791160510836.6ed7f08c.jpg";